"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnreadPortsError = exports.assertAllPortsRead = exports.UnassembledPortsError = exports.assertAssembled = exports.renderComponentDiagram = exports.diffContractDocuments = exports.NO_OBSERVER = exports.portFailure = exports.guard = exports.contractsOf = exports.describePorts = exports.PortHolder = exports.Connector = exports.ProvidedPort = exports.Port = void 0;
/**
 * SOLID Review
 * S — Strong. The package's public surface and nothing else; no logic of its own.
 * O — Good. A new kernel type is one more export line.
 * L — N/A — no inheritance hierarchy.
 * I — Acceptable. One entry point for a small, cohesive kernel. Consumers that want only the
 *     descriptor types still import the whole package, which is the normal trade for a barrel;
 *     the alternative (subpath exports) buys nothing at eight files.
 * D — Strong. Re-exports only; depends on nothing outside this package.
 */
/**
 * The UML Port kernel, shared by `backend` and `frontend` (handbook §28.40).
 *
 * WHY A SEPARATE WORKSPACE. rev4 E.2 converts the frontend's 15 registry slots into sockets, which
 * needs this kernel on both sides. It previously lived in `backend/src/`, where the frontend cannot
 * reach it: separate npm workspaces, no path alias, and no dependency-cruiser rule contemplating a
 * cross-workspace import. §28.40 recorded the decision — a third workspace, not a path alias
 * (which would make the frontend build depend on backend source layout) and not duplication
 * (which is what commit 921e83f deleted).
 *
 * WHAT IS SHARED, and why it is the whole kernel rather than the two files first proposed: the
 * frontend's infrastructure adapters SUPPLY interfaces, so they need `ProvidedPort` and
 * `Connector` exactly as the backend does. Splitting the kernel by side would put the assembly
 * mechanism in one workspace and half its vocabulary in another.
 *
 * THE SIDE-SPECIFIC CONSTRAINT IS A GATE, NOT A COMMENT. Both required-port variants live here,
 * and dependency-cruiser enforces which side may use which:
 *
 *   - `backend/src/**` must not import `RequiredPortWithDefault` — a server that boots half-wired
 *     serves wrong answers instead of refusing to start.
 *   - `frontend/src/**` must not import `RequiredPort` — a UI that throws on a missing adapter
 *     white-screens where a Null object would have degraded (§28.21, and the outage in §28.33).
 *
 * Both rules are at `error`, and each was observed failing on a deliberate violation before being
 * trusted (§29.5). Before this, the constraint was a paragraph in a file header.
 *
 * NOTE WHAT IS MISSING BELOW. Neither required-port variant is re-exported here. dependency-cruiser
 * matches module PATHS, not named imports, so a barrel exporting both would make those rules
 * unenforceable — every consumer would depend on '@ml3d/kernel' and the gate could not tell which
 * class it took. Each variant has its own subpath instead:
 *
 *     import { RequiredPort } from '@ml3d/kernel/required';                          // backend
 *     import { RequiredPortWithDefault } from '@ml3d/kernel/required-with-default';  // frontend
 *
 * The extra keystrokes are the point: the choice is visible at the call site, and wrong-side use is
 * a gate failure rather than something a review might wave through.
 */
var Port_1 = require("./Port");
Object.defineProperty(exports, "Port", { enumerable: true, get: function () { return Port_1.Port; } });
var PortProvided_1 = require("./PortProvided");
Object.defineProperty(exports, "ProvidedPort", { enumerable: true, get: function () { return PortProvided_1.ProvidedPort; } });
var Connector_1 = require("./Connector");
Object.defineProperty(exports, "Connector", { enumerable: true, get: function () { return Connector_1.Connector; } });
var PortHolder_1 = require("./PortHolder");
Object.defineProperty(exports, "PortHolder", { enumerable: true, get: function () { return PortHolder_1.PortHolder; } });
var describe_1 = require("./describe");
Object.defineProperty(exports, "describePorts", { enumerable: true, get: function () { return describe_1.describePorts; } });
Object.defineProperty(exports, "contractsOf", { enumerable: true, get: function () { return describe_1.contractsOf; } });
var PortContract_1 = require("./PortContract");
Object.defineProperty(exports, "guard", { enumerable: true, get: function () { return PortContract_1.guard; } });
Object.defineProperty(exports, "portFailure", { enumerable: true, get: function () { return PortContract_1.portFailure; } });
Object.defineProperty(exports, "NO_OBSERVER", { enumerable: true, get: function () { return PortContract_1.NO_OBSERVER; } });
var contractDiff_1 = require("./contractDiff");
Object.defineProperty(exports, "diffContractDocuments", { enumerable: true, get: function () { return contractDiff_1.diffContractDocuments; } });
var renderComponentDiagram_1 = require("./renderComponentDiagram");
Object.defineProperty(exports, "renderComponentDiagram", { enumerable: true, get: function () { return renderComponentDiagram_1.renderComponentDiagram; } });
var assertAssembled_1 = require("./assertAssembled");
Object.defineProperty(exports, "assertAssembled", { enumerable: true, get: function () { return assertAssembled_1.assertAssembled; } });
Object.defineProperty(exports, "UnassembledPortsError", { enumerable: true, get: function () { return assertAssembled_1.UnassembledPortsError; } });
var assertAllPortsRead_1 = require("./assertAllPortsRead");
Object.defineProperty(exports, "assertAllPortsRead", { enumerable: true, get: function () { return assertAllPortsRead_1.assertAllPortsRead; } });
Object.defineProperty(exports, "UnreadPortsError", { enumerable: true, get: function () { return assertAllPortsRead_1.UnreadPortsError; } });
//# sourceMappingURL=index.js.map